import React from 'react';

import InputGroupBlock from 'blocks/InputGroupBlock';
import FormLabel from 'elements/FormLabel';
import InputMessage from 'elements/InputMessage';
import FileUploadInput, { FileUploadInterface } from './FileUploadInput';

export const FileUploadComponent = (props: FileUploadInterface) => {
  const id = props.id ? props.id : '__formfield_' + props.name;
  return (
    <InputGroupBlock error={!!props.error}>
      {props.label && <FormLabel htmlFor={id}>{props.label}</FormLabel>}
      {props.error && <InputMessage>{props.error}</InputMessage>}
      <FileUploadInput id={id} {...props} />
    </InputGroupBlock>
  );
};

export default FileUploadComponent;
